module.exports = __webpack_public_path__ + "img/play-icon.15212c58.svg";